import { FontAwesome5 } from '@expo/vector-icons';
import {
  OEText,
  flex,
  ph,
  mr,
  width,
  height,
  OETextInput,
} from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { View } from 'react-native';
import { DataTable } from 'react-native-paper';

import { cellFlex } from './active-class-card.helper';

interface ActiveClassCardTableHeaderProps {
  onSortChange: (_field: string) => void;
  onFilterChange: (_field: string, _value: string) => void;
  totalStudent: number;
  sortDirection?: string;
  sortField?: string;
}
export const ActiveClassCardTableHeader = ({
  onSortChange,
  onFilterChange,
  totalStudent,
  sortField,
  sortDirection,
}: ActiveClassCardTableHeaderProps) => {
  const fields = {
    link: 'Link',
    teacherPresent: 'Status',
    id: 'ID',
    teacherName: 'Teacher',
    w2wID: 'Faculty ID',
    role: 'Role',
    studentNames: `Student (${totalStudent})`,
    classBegin: `Start`,
    title: `Title`,
    teachingTime: `Duration`,
    language: `Lang`,
    levelId: `Level`,
  };
  return (
    <>
      <DataTable.Header style={[ph(0)]}>
        {Object.entries(fields).map(([field, label]) => {
          let sortIcon = 'sort';
          if (field === sortField) {
            if (sortDirection === 'asc') {
              sortIcon = 'sort-down';
            } else {
              sortIcon = 'sort-up';
            }
          }
          return (
            <Title
              key={field}
              onPress={() => onSortChange(field)}
              flex={cellFlex?.[field] || 1}
              style={field === 'status' && flex('justify-content-center')}
            >
              {field !== 'link' && (
                <FontAwesome5 style={mr(4)} name={sortIcon} />
              )}
              <OEText fontType="bold" fontSize={14}>
                {label}
              </OEText>
            </Title>
          );
        })}
      </DataTable.Header>
      <DataTable.Header style={[ph(0)]}>
        {Object.entries(fields).map(([field, label]) => {
          return (
            <FilterCell key={field} flex={cellFlex?.[field] || 1}>
              {['link', 'state', 'classBegin'].includes(field) ? (
                <View key={field} />
              ) : (
                <OETextInput
                  key={field}
                  placeholder={label}
                  style={[width('100%'), height(30)]}
                  onChangeText={(text: string) => onFilterChange(field, text)}
                />
              )}
            </FilterCell>
          );
        })}
      </DataTable.Header>
    </>
  );
};

type FlexProps = {
  flex: number;
};
const FilterCell = styled(DataTable.Cell)<FlexProps>`
  padding-horizontal: 4px;
  flex: ${({ flex }) => flex};
`;
const Title = styled(DataTable.Title)<FlexProps>`
  padding-horizontal: 4px;
  flex: ${({ flex }) => flex};
  cursor: pointer;
`;
